module.exports = __webpack_public_path__ + "static/media/timerKds.8deab6d3.svg";